import { render, staticRenderFns } from "./PedidosTab.vue?vue&type=template&id=611a8e06"
import script from "./PedidosTab.vue?vue&type=script&lang=js"
export * from "./PedidosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports